import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { Subscription, switchMap } from 'rxjs';

import { ButtonTypesEnum } from '../../../Common/Forms/enums/button-types.enum';
import { ConfigService } from '../../../Core/Config/services/config.service';
import { LocalizationService } from '../../../Core/Localization/services/localization.service';
import { CurrentUserStateService } from '../../../Core/Users/services/current-user-state.service';
import { partnerResellerConfigs } from '../../config/resellers/reseller-config-model';

@Component({
    selector: 'agpr-terms-and-conditions',
    templateUrl: './terms-and-conditions.component.html',
    styleUrls: ['./terms-and-conditions.component.scss'],
    standalone: false
})
export class TermsAndConditionsComponent implements OnDestroy {
    readonly buttonTypes = ButtonTypesEnum;
    logoUrl: string;
    logoAltText: string;
    scrolledToBottom: boolean = false;
    isResellerDomain: boolean = false;
    body: string;

    acceptSubscription: Subscription;

    constructor(
        @Inject(APP_BASE_HREF) public appBaseHref: string,
        private router: Router,
        private configService: ConfigService,
        private currentUserService: CurrentUserStateService,
        private localizationService: LocalizationService
    ) {
        this.logoUrl = appBaseHref + 'assets/images/agility-logo-horizontal.png';
        this.logoAltText = 'Core.login.agility';

        const isLexisNexis: boolean = this.configService.brandGUIDIsLexisNexis();

        if (isLexisNexis) {
            this.body = this.localizationService.transform('Core.termsOfService.acknowledge.lexis');
        } else {
            this.body = this.localizationService.transform('Core.termsOfService.acknowledge');
        }

        if (this.configService.hasBrandGUID()) {
            this.isResellerDomain = true;
            const resellerConfig = partnerResellerConfigs.get(this.configService.getPartnerReseller());
            if (resellerConfig) {
                this.logoUrl = resellerConfig.logoUrl;
                this.logoAltText = resellerConfig.logoAltText;
            }
        }
    }

    accept() {
        this.acceptSubscription = this.currentUserService.acceptTos().pipe(
            switchMap(() => this.currentUserService.getAccount())
        ).subscribe(account => {
            if (!account?.ssoProvider) {
                this.router.navigate(['SetPassword']);
            } else {
                this.router.navigate(['Dashboard']);
            }
        });
    }

    decline() {
        this.router.navigate(['Logout']);
    }

    ngOnDestroy(): void {
        this.acceptSubscription?.unsubscribe();
        this.acceptSubscription = null;
    }
}
